import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutesName } from '../../const/AppRoutesName';

export const routes: Routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.FR.CONTACT,
    loadComponent: () =>
      import('./contact.component').then((m) => m.ContactComponent),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.CONTACT,
    loadComponent: () =>
      import('./contact.component').then((m) => m.ContactComponent),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ContactModule {}
